import React, {useMemo} from 'react';
import {SalesforceContact, SalesforceContactField} from 'api';
import Text from './Text';
import Date from './Date';
import Name from './Name';
import Checkbox from './Checkbox';

interface Props {
  field: SalesforceContactField;
  salesforceContact: SalesforceContact;
}

export const FieldValue: React.FC<Props> = ({field, salesforceContact}) => {
  const Value = useMemo(() => {
    const value = salesforceContact.addition[`${field.fieldName}`];

    if (field.fieldType === 'checkbox') {
      return <Checkbox field={field} salesforceContact={salesforceContact} />;
    } else if (field.fieldType === 'address') {
      const hash = value;
      if (!hash) {
        return null;
      }
      const address = `${hash?.state}${hash?.city}${hash?.street}`;
      return <div>{address}</div>;
    } else if (
      ['text', 'phone'].includes(field.fieldType) &&
      field.updateable
    ) {
      return <Text field={field} salesforceContact={salesforceContact} />;
    } else if (field.fieldType === 'date' && field.fieldName.endsWith('__c')) {
      return <Date field={field} salesforceContact={salesforceContact} />;
    } else if (field.fieldName === 'Name') {
      return <Name field={field} salesforceContact={salesforceContact} />;
    } else {
      return <div>{value}</div>;
    }
  }, [field, salesforceContact.addition]);

  return (
    <div className="flex px-4 align-middle text-foreground">
      <div className="w-2/5 text-sm ">{field.label}</div>
      <div className="w-3/5">{Value}</div>
    </div>
  );
};
